import { useTranslation } from 'react-i18next';
import { decode } from 'html-entities';
import { sanitizeHtml } from '@r/utils/sanitize-html.ts';

const useFormatTextToHtml = (): ((textInput: string | null | undefined) => string | null) => {
  const { t, i18n } = useTranslation();

  return (textInput: string | null | undefined): string | null => {
    if (!textInput) {
      return null;
    }

    const sanitizedText = sanitizeHtml(i18n.exists(textInput) ? t(textInput) : textInput);
    const decodedText = decode(sanitizedText);

    // Remplace \r, \n, \r\n par <br /> (sans lookbehind pour compatibilité étendue)
    return decodedText.replace(/\r\n|\r|\n/g, '<br />');
  };
};

export { useFormatTextToHtml };
